import React, { useEffect, useState } from 'react'
import swal from 'sweetalert'
import { useHistory } from 'react-router-dom'
import Services from '../services/Services'

function ContactUs(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const history = useHistory()
  const services = new Services(this)

  const [fields, setFields] = useState({
    name: '',
    phone: '',
    email: '',
    city: '',
    message: '',
  })

  const handleFieldChange = (e) => {
    setFields({
      ...fields,
      [e.target.id]: e.target.value,
    })
  }

  const contactUsNow = (e) => {
    e.preventDefault()
    services.contactUs(fields).then((resp) => {
      setFields({
        name: '',
        phone: '',
        email: '',
        city: '',
        message: '',
      })
      swal({
        title: 'Success!',
        text: 'Message sent!',
        icon: 'success',
        timer: 1500,
      })
    })
  }

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page">
        <section
          className="hero-banner inner-banner form-page"
          style={{
            backgroundImage: `url('images/contact_us/contact.jpg')`,
            height: 600,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-7"></div>
              <div
                className="col-lg-5 col-md-12 col-sm-12"
                style={{ textAlign: 'right' }}
              >
                <div className="partner-banner-content pt-183">
                  <h1 style={{ textShadow: '3px 3px #222222' }}>
                    Talk to the RoadJockey Family
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="benefit-sec lgreen-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="col-lg-8 offset-lg-2 text-center">
                  <div className="about-content">
                    <h2>Contact the RoadJockey Family</h2>
                    <p>
                      We are always willing to answer questions and offer
                      quality support to all our Roadies,
                      <br />
                      Food Partners, and anyone else interested in our service.
                      Please use our contact form, and we will respond in a
                      timely manner You can also email us at{' '}
                      <a href="mailto:info@RoadJockeyJA.com">
                        info@RoadJockeyJA.com
                      </a>
                      .<br />
                      Thank you for contacting RoadJockey!{' '}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="partner-form">
                  <div className="heading-text border-bottom">
                    <h3>Send us a Message</h3>
                    <p>Please fill the form below so we know what you need.</p>
                  </div>
                  <form>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="yourname"
                            id="name"
                            placeholder="Name"
                            value={fields.name}
                            onChange={handleFieldChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="email"
                            name="emaiaddress"
                            id="email"
                            value={fields.email}
                            onChange={handleFieldChange}
                            placeholder="Email"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="phonenumber"
                            id={'phone'}
                            value={fields.phone}
                            onChange={handleFieldChange}
                            placeholder="Phone"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="cityname"
                            id={'city'}
                            value={fields.city}
                            onChange={handleFieldChange}
                            placeholder="City"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            placeholder="Message"
                            value={fields.message}
                            id={'message'}
                            onChange={handleFieldChange}
                            rows="4"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <p>
                          By clicking ‘Submit’, you agree to{' '}
                          <a href="#">RoadJockeyGeneral Terms and Conditions</a>{' '}
                          and acknowledge that you have read the{' '}
                          <a href="#">Privacy Policy.</a>
                        </p>
                      </div>
                      <div className="col-lg-12">
                        <button className="primary-btn" onClick={contactUsNow}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default ContactUs
